import {useIsAuthenticated} from "./useIsAuthenticated";

export const useDashboardLoginURL = () => {
  const {isAuthenticated} = useIsAuthenticated();
  const dashboardLoginURL = `${process.env.NEXT_PUBLIC_DASHBOARD_BASE_URL}${isAuthenticated ? "/auth/login" : "/auth"}`;
  return dashboardLoginURL;
};
